import styled, { css } from 'styled-components';
import { InputTelProps } from './InputTel';
import { InputElement as TextFieldElement } from '@/components/form/TextField/TextField.styles';
import { Element as FieldGroupElement } from '@/components/form/FieldGroup/FieldGroup.styles';

export const FieldGroup = styled(FieldGroupElement)`
  ${({ theme, ...props }) => {
    return css`
      .iti {
        position: relative;
        display: inline-block;
        width: 100%;
      }
      .iti * {
        box-sizing: border-box;
      }
      .iti__hide {
        display: none;
      }
      .iti__v-hide {
        visibility: hidden;
      }
      .iti input,
      .iti input[type='text'],
      .iti input[type='tel'] {
        position: relative;
        z-index: 0;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-right: 36px;
        margin-right: 0;
      }
      .iti__flag-container {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        padding: 1px;
      }
      .iti__selected-flag {
        z-index: 1;
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 6px 0 8px;
      }
      .iti__arrow {
        margin-left: 6px;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-top: 4px solid ${theme.color.neutral_500};
      }
      [dir='rtl'] .iti__arrow {
        margin-right: 6px;
        margin-left: 0;
      }
      .iti__arrow--up {
        border-top: none;
        border-bottom: 4px solid ${theme.color.neutral_500};
      }
      .iti__country-list {
        position: absolute;
        z-index: 2;
        list-style: none;
        padding: 0;
        margin: 0 0 0 -1px;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
        background-color: white;
        border: 1px solid ${theme.color.neutral_100};
        white-space: nowrap;
        max-height: 200px;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        border-radius: ${theme.radius.xs};
      }
      .iti__country-list--dropup {
        bottom: 100%;
        margin-bottom: -1px;
      }
      @media (max-width: 500px) {
        .iti__country-list {
          white-space: normal;
        }
      }
      .iti__flag-box {
        display: inline-block;
        width: 20px;
      }
      .iti__divider {
        padding-bottom: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid ${theme.color.neutral_500};
      }
      .iti__country {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        outline: none;
      }
      .iti__dial-code {
        color: ${theme.color.neutral_500};
      }
      .iti__country.iti__highlight {
        background-color: rgba(0, 0, 0, 0.05);
      }
      .iti__flag-box,
      .iti__country-name {
        margin-right: 6px;
      }
      [dir='rtl'] .iti__flag-box,
      [dir='rtl'] .iti__country-name {
        margin-right: 0;
        margin-left: 6px;
      }
      .iti--allow-dropdown input,
      .iti--allow-dropdown input[type='text'],
      .iti--allow-dropdown input[type='tel'],
      .iti--separate-dial-code input,
      .iti--separate-dial-code input[type='text'],
      .iti--separate-dial-code input[type='tel'] {
        padding-right: 6px;
        padding-left: 52px;
        margin-left: 0;
      }
      [dir='rtl'] .iti--allow-dropdown input,
      [dir='rtl'] .iti--allow-dropdown input[type='text'],
      [dir='rtl'] .iti--allow-dropdown input[type='tel'],
      [dir='rtl'] .iti--separate-dial-code input,
      [dir='rtl'] .iti--separate-dial-code input[type='text'],
      [dir='rtl'] .iti--separate-dial-code input[type='tel'] {
        padding-right: 52px;
        padding-left: 6px;
        margin-right: 0;
      }
      .iti--allow-dropdown .iti__flag-container,
      .iti--separate-dial-code .iti__flag-container {
        right: auto;
        left: 0;
      }
      [dir='rtl'] .iti--allow-dropdown .iti__flag-container,
      [dir='rtl'] .iti--separate-dial-code .iti__flag-container {
        right: 0;
        left: auto;
      }
      .iti--allow-dropdown .iti__flag-container:hover {
        cursor: pointer;
      }
      .iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag {
        background-color: rgba(0, 0, 0, 0.05);
      }
      .iti--allow-dropdown input[disabled] + .iti__flag-container:hover,
      .iti--allow-dropdown input[readonly] + .iti__flag-container:hover {
        cursor: default;
      }
      .iti--allow-dropdown input[disabled] + .iti__flag-container:hover .iti__selected-flag,
      .iti--allow-dropdown input[readonly] + .iti__flag-container:hover .iti__selected-flag {
        background-color: transparent;
      }
      .iti--separate-dial-code .iti__selected-flag {
        background-color: rgba(0, 0, 0, 0.05);
      }
      .iti--separate-dial-code.iti--show-flags .iti__selected-dial-code {
        font-size: ${theme.typography.font_size.text_sm};
        margin-left: 6px;
      }
      [dir='rtl'] .iti--separate-dial-code.iti--show-flags .iti__selected-dial-code {
        margin-left: 0;
        margin-right: 6px;
      }
      .iti--container {
        position: absolute;
        top: -1000px;
        left: -1000px;
        z-index: 1060;
        padding: 1px;
      }
      .iti--container:hover {
        cursor: pointer;
      }

      .iti-mobile .iti--container {
        top: 30px;
        bottom: 30px;
        left: 30px;
        right: 30px;
        position: fixed;
      }
      .iti-mobile .iti__country-list {
        max-height: 100%;
        width: 100%;
      }
      .iti-mobile .iti__country {
        padding: 10px 10px;
        line-height: 1.5em;
      }

      .iti__flag.iti__np {
        background-color: transparent;
      }

      .iti__standard,
      .iti__preferred {
        font-size: ${theme.typography.font_size.text_sm};
      }

      .iti__standard {
        .iti__country-name {
          max-width: 15rem;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    `;
  }};
`;

export const InputElement = styled(TextFieldElement)<InputTelProps>`
  ${({ theme, ...props }) => {
    return css`
      width: 100% !important;
      + input {
        display: none;
      }
    `;
  }};
`;
